export enum VehicleLicensePlateType {
    CAR = 'CAR',
    MOTORCYCLE = 'MOTORCYCLE',
}

export interface ParkingaboVehicle {
    customerTenantCarId: string;
    identificationQrCodeId: string | null;
    description: string;
    licensePlateNr: string | null;
    type: VehicleLicensePlateType | null;
    country: string | null;
    badgeId: number | null;
    badgeLabelNr: string | null;
    badgeType: ParkingaboUserBadgeType | null;
    lastModified: ParkingaboVehicleHistory | null;
    hasOpenEntryWithoutExit: boolean;
}

export interface ParkingaboVehicleHistory {
    actionAt: string;
    type: ParkingaboVehicleHistoryType;
    modifiedBy: string | null;
}

export enum ParkingaboVehicleHistoryType {
    OPERATOR_LOGIN = 'OPERATOR_LOGIN',
    PARKINGABO_LOGIN = 'PARKINGABO_LOGIN',
    EXTERNAL_ACCESS_TOKEN = 'EXTERNAL_ACCESS_TOKEN',
    UNKNOWN = 'UNKNOWN',
}

export enum ParkingaboUserBadgeType {
    ParkingpayBadge = 'ParkingpayBadge',
    ParkingaboBadge = 'ParkingaboBadge',
}

export enum BarrierGateLicensePlateCheckInOption {
    INACTIVE = 'INACTIVE',
    ACTIVE = 'ACTIVE',
    OCCUPIED = 'OCCUPIED',
    NOT_ALLOWED_TOO_SHORT = 'NOT_ALLOWED_TOO_SHORT',
    NOT_ALLOWED_MOTORCYCLE = 'NOT_ALLOWED_MOTORCYCLE',
    NOT_ALLOWED_DIPLOMATIC = 'NOT_ALLOWED_DIPLOMATIC',
}
